import React from "react";
const loading = () => {
  return (
        <div className="row h-100 justify-content-center align-items-center">
          <mosaic-spinner width="48" height="48" animated />
        </div>  
  );
};

export default loading;
